/**
 * Builder template archive scripts
 * 
 * @since 1.1.0
 * @package shuffled
 */

(function($) {
	$(document).ready(function() {

		var body = $( 'body' );

		if (
			body.hasClass( 'post-type-archive-builder_template' ) ||
			body.hasClass( 'tax-builder_category' )
		) {

			// elements
			var toggler		= $( '#toggle-categories' );
			var categories	= $( '[role="main"] > section > aside > nav' );

			// toggle category menu
			function toggleCategories() {
				categories.slideToggle( 250 );
				toggler.toggleClass( 'toggled' );
			}

			// mobile category menu toggle
			toggler.on( 'click', toggleCategories );

		} // if template archive
	}); // document.ready
})(jQuery);